import providerRoutes from "./providers"
import consumerRoutes from "./consumers"
import monitorRoutes from "./monitor"
import prepareRoutes from "./prepare"
import governRoutes from "./govern"
import applicationRoutes from "./applications"

const appRoutes = [
  {
    path: "",
    name: "",
    component: () => import("@/layout/DashboardLayout.vue"),
    redirect: "/home",
    meta: {
      isProtected: true
    },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/modules/home/pages/Home.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Home",
              translationKey: "common.home",
              routeName: "home"
            }
          ]
        }
      },
      ...providerRoutes,
      ...monitorRoutes,
      ...prepareRoutes,
      ...consumerRoutes,
      ...governRoutes,
      ...applicationRoutes
    ]
  }
]

export default appRoutes
